<template>
    <div>
        <Modal v-model="modalPay" width="700" :footer-hide="true" :mask-closable="false" class="vipmodal" @on-cancel="closeQRPay" :closable="true" title=''>
          <!--   <p slot="header" style="color:brown;text-align:center;font-size:16px;">
                <span>支付</span>
            </p> -->
            
            <p style="text-align: center;font-size: 16px;padding-top: 10px;">实付金额:<span style="font-size: 24px;color:#FF3400;font-weight: bold;">{{totalBill}}</span><span style="color:#FF3400;">元</span></p>
            <div v-if="orderState===0" style="width:100%;text-align: center;">
                <!-- <img src="../../assets/images/zzyq_qrcode.jpg"> -->
                <p style="width:100%;text-align: center;">订单编号:{{orderid}}</p>
                <div id="maskqr" style="position: relative;padding-top: 10px;">
                <img :src="base64str" class="qr-code-img" style="border:1px solid #19be6b;width: 30%;height: 30%;margin:5px;border-radius: 5px;"></img>
                <Spin size="large" fix v-if="!agreementChecked"></Spin>
                </div>
                <div style="text-align: center;font-size: 18px;">
                <div v-if="payChange==='微信'">
                    <i class="iconfont" style="color: #19c105;font-size: 16px;">&#xe650;</i>
                    <span style="font-size: 16px;">微信支付</span>
                </div>
                <div v-else>
                    <i class="iconfont" style="color: #00aaee;">&#xe618;</i>
                    <span style="color: #00aaee;">支付宝支付</span>
                </div>
            </div>
                <div class="agreement-content">
                    <Checkbox style="margin-right: 0px;" v-model="agreementChecked">我已认真阅读并同意用户协议</Checkbox>《<span class="agreement-user" @click="showAgreement">用户协议</span>》
                </div>
                <br />
                <p style="width:100%;text-align: center;"><Icon size="16" type="md-alert" color="#ff9900" />请于5分钟内完成支付,逾期订单失效</p>
                <br />
            </div>
            <div v-else-if="orderState===100" style="width:100%;text-align: center;">
                <p>
                    <Icon size="50" type="md-checkmark-circle" color="#19be6b" />
                </p>
                <p style="width:100%;text-align: center;font-size: 20px;">您的订单支付成功</p>
                <p style="width:100%;text-align: center;padding-top: 40px;"><Button type="success" style="width:200px;" @click="closeQRPay">确定</Button></p>
                <br />
                <p style="width:100%;text-align: center;font-size: 14px;">支付窗口将于{{totalSec}}秒后关闭</p>
            </div>
            <div v-else style="width:100%;text-align: center;">
                <p>
                    <Icon size="50" type="md-alert" color="#ff9900" />
                </p>
                <p style="width:100%;text-align: center;font-size: 20px;">订单支付失败:{{payErrDesc}}</p>
                <br />
            </div>
        </Modal>

    </div>
</template>
<script>
import { mapGetters,mapActions } from 'vuex'
import ConstJson from '../../api/common/constjson'
import store from "../../store/"
let constJ = new ConstJson()
export default {
    data() {
        return {
            agreementChecked:true,
        	base64str:'',
            modalPay: false,
            payChange:'微信',
            totalBill: 0,
            orderState: 0,
            totalSec:0,
            payErrDesc: '',
            orderid:'',
            isQueryPayState:false,
        }
    },
    components:{
        
    },
    computed: {
        ...mapGetters(['getUserId', 'sta']),
    },
    methods:{
        //...mapActions(['flashToken']),
        showAgreement() {
            //this.$refs.product_agreement.show()
            this.$emit('showAgreement')
        },
    	show(data){
            this.orderState=0
    		console.log('show QR pay---->')
    		this.payChange=data.payChange
    		this.totalBill=data.totalBill
    		this.base64str=data.base64str
    		this.orderid=data.orderid
    		this.modalPay=true
    		//开启轮询
    		this.isQueryPayState=true
    		this.checkOrderPayState(this.orderid)
    	},
        autoClose() {
            this.totalSec=5
            let that = this
            let clock = window.setInterval(() => {
                console.log('di--->')
                if (that.totalSec === 0) {
                    that.closeQRPay()
                    window.clearInterval(clock)
                    return
                }else{
                    that.totalSec--
                }
                
            }, 1000)
        },
        ////////////////////////////////////////////////////////////////////////////////////////
        getOrderState(orderid, clock) {
            let k = this.$Tools.getPayState()
            if (!this.isQueryPayState) {
                window.clearInterval(clock)
                return
            }
            constJ.reqGetOrderState(orderid).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    this.orderState = res.status.paystatus
                    if (res.status.paystatus === k.PAYSTATUS_PAYEND) {
                        this.$Message.success('支付成功')
                        this.isPaySuccess = true
                        this.$emit('paySuccess')
                        console.log("clearInterval...")
                        window.clearInterval(clock)
                        //关闭倒计时
                        this.autoClose()

                        //执行session登录刷新用户权限
                        console.log('刷新登录权限==>')
                        //this.flashToken()
                        //this.closeQRPay()
                        return
                    } else if (res.status.paystatus === k.PAYSTATUS_WAITINGPAY) {
                        //轮询支付结果，当前状态：等待支付
                        //this.$Message.warning(res.status.paystatusdesc)

                    } else if (res.status.paystatus < 0) {
                        this.$Message.warning(res.status.paystatusdesc)
                        this.payErrDesc = res.status.paystatusdesc
                        window.clearInterval(clock)
                        return
                    }
                } else {
                    if (res.rltcode < 0) {
                        this.$Message.warning(res.rltdesc)
                        window.clearInterval(clock)
                        return
                    } else if (res.rtncode < 0) {
                        this.$Message.warning(res.rtndesc)
                        window.clearInterval(clock)
                        return
                    }
                }
            })
        },
        checkOrderPayState(orderid) {
            let clock = window.setInterval(() => {
                this.getOrderState(orderid, clock)
            }, 2000)


        },
        closeQRPay() {
            this.isQueryPayState = false
            this.modalPay = false
        },
        //////////////////////////////////////////////////////////////////////////////////////
    }
}
</script>
<style lang="less" scoped>
@font-face {
    font-family: 'iconfont';
    /* project id 1804652 */
    src: url('//at.alicdn.com/t/font_1804652_306rskp3iol.eot');
    src: url('//at.alicdn.com/t/font_1804652_306rskp3iol.eot?#iefix') format('embedded-opentype'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.woff2') format('woff2'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.woff') format('woff'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.ttf') format('truetype'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.svg#iconfont') format('svg');
}

.iconfont {
    font-size: 16px;
    font-family: 'iconfont';
    margin-right: 10px;
}
/*pay modal*/
.vipmodal/deep/.ivu-modal-body {
    padding: 0px;
}

.vipmodal/deep/.ivu-modal-header {
    background-color: #FEE7AA;
}


h2 {
    height: 75px;
    line-height: 50px;
    text-align: center;
}

.scentitle {
    font-size: 10px;
    color: #ccc;
    line-height: 50px;
    text-align: center;
}

.card-title-desc {
    font-size: 12px;
    color: #808695;
    height: 20px;
    line-height: 20px;
    margin-top: 5px;
}
/////////////////////////////


.agreement-content {
    margin-top: 10px;
    font-size: 10px;
    text-align: center;
}

#maskqr/deep/.ivu-spin-fix {
    background-color: rgba(255, 255, 255, 1);
}

.agreement-user {
    font-size: 10px;
    color: #4386f5;
    cursor: pointer;
}


</style>